export enum SpecialDayOfMonth {
	firstMondayOfMonth = "generico.firstMondayOfMonth",
	firstDayOfMonth = "generico.firstDayOfMonth",
}
